"use strict";

exports.__esModule = true;
var _AppFooter = _interopRequireDefault(require("./AppFooter"));
exports.default = _AppFooter.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}